export const endpoints = {
  GET_ALL_IAM_PROFILES: '/api/iam/profiles',
  GET_IAM_PROFILE_BY_ID: '/api/iam/profiles/:id',
  GET_IAM_ROLE_BY_ID: '/api/iam/roles/:id',
};
